import { type FC, type ReactNode } from "react";
import classNames from "classnames";
import { Card, type CardProps } from "~/features/configurator/Linear/components/Card";
import { styled } from "~/common/mui";

const SectionRoot = styled("div")({
  display: "flex",
  flexDirection: "column",
});

const SectionCard = styled(Card)(({ theme }) => ({
  flex: 1,
  marginTop: theme.spacing(3.75),
  padding: theme.spacing(3.75),
  display: "flex",
  flexDirection: "column",
}));

const SectionTitle = styled("h3")(({ theme }) => ({
  ...theme.typography.headlineSmall,
  marginTop: 0,
  marginBottom: 0,
}));

const SectionDescription = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(2.5),
}));

export const SASection: FC<{ className?: string; id?: string; children?: ReactNode }> = ({ className, ...rest }) => {
  return <SectionRoot className={classNames("scha__sa__section", className)} {...rest} />;
};

export const SASectionTitle = ({ className, ...rest }: JSX.IntrinsicElements["h3"]) => (
  <SectionTitle className={className} {...rest} />
);

export const SASectionDescription = ({ className, ...rest }: JSX.IntrinsicElements["div"]) => (
  <SectionDescription className={className} {...rest} />
);

export const SASectionContents = <T extends keyof JSX.IntrinsicElements>({ className, ...rest }: CardProps<T>) => {
  // @ts-ignore
  return <SectionCard className={classNames("scha__sa__section__contents", className)} disableHover={true} {...rest} />;
};
